import { createContext } from 'react';
export const defaultState = {
    device: null,
    deviceConfig: null,
    entity: null,
    deviceHistory: null,
    lns: null,
    nodeEdgeMapper: null,
    deviceEnabledTypeIds: null,
    broadcastScheduleObject: null,
    downlinkQueue: null,
    downlinkHistory: null,
};
export const DeviceContextReducer = (prev, next) => {
    const update = { ...prev, ...next };
    return update;
};
export const DeviceConfigContext = createContext({
    state: defaultState,
    dispatch: () => {
        throw new Error('Dont use uninitialized DeviceContext');
    },
});
